module.exports = __webpack_public_path__ + "fonts/fa-light-300.5ce1b436780d4a536fbe0907ce99c719.woff";